export default __webpack_public_path__ + "img/31552591d0ca7edc32828210cb048e8f.gif";